<script>
/**
const APP_SERVER_URL = {
    host: "http://localhost:922",
    postfix: "/"
};
const serverHost = 'http://www.sslbk.com';
const serverH5 = 'https://m.shushizi.com';

*/
// -----------------打包用
const APP_SERVER_URL = {
     host: window.location.origin,
     postfix: "/"
};
const serverHost = APP_SERVER_URL.host;
const serverH5 = window.location.protocol+'//m.'+(window.location.hostname).match(/[^.]+\.[^.]+$/)[0];


const serverUrl =  APP_SERVER_URL.host + APP_SERVER_URL.postfix; // API接口前缀

export default {
	serverUrl,
	serverHost,
	serverH5
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/router/Api.vue